module.exports = __webpack_public_path__ + "img/prev-arrow.284a0705.svg";